import * as z from "zod"

export const TenantModel = z.object({
  id: z.string(),
  created_at: z.date(),
  updated_at: z.date(),
  impersonation_contact_id: z.number().int().nullish(),
})
